<div class="flex flex-row items-center gap-2">
    <input type="text" class="flex-1 input input-bordered" [(ngModel)]="updatedEmail.email" [disabled]="!editMode" />
    <select class="select select-bordered mr-5" i18n-placeholder placeholder="Art" [(ngModel)]="updatedEmail.type" [disabled]="!editMode">
        <option *ngFor="let type of contactInformationTypes" [value]="type">
            {{ getContactInformationTypeDescription(type) }}
        </option>
    </select>
    <button *ngIf="!editMode" (click)="editMode = true">
        <iota-icon icon="pencil-square" class="text-primary"></iota-icon>
    </button>
    <button *ngIf="!editMode" class="btn btn-error" (click)="delete.emit(updatedEmail)">
        <iota-icon icon="trash"></iota-icon>
    </button>
    <button *ngIf="editMode" class="btn btn-accent" (click)="saveEmail()">
        <iota-icon flaticon="floppy-disk" size="1x"> </iota-icon>
    </button>
    <button *ngIf="editMode" class="btn btn-accent" (click)="cancelEditing()">
        <iota-icon icon="x-mark"></iota-icon>
    </button>
</div>
